export const sleep = async (ms: number) => await new Promise((resolve) => setTimeout(resolve, ms));

export const waitAndReject = async (ms: number, error: string) => await new Promise((_, reject) => setTimeout(() => {
  reject(error);
}, ms));

export async function wrapPromiseInTimeout(
  promiseToRaceAgainst: Promise<void>,
  timeoutMs: number,
  errorMessage: string): Promise<void | unknown> {
  return Promise.race([promiseToRaceAgainst, waitAndReject(timeoutMs, errorMessage)]);
}
